module.exports = __webpack_public_path__ + "img/banner-antifraude.30398e06.jpg";